import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const DuplicateCopyIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M14.1663 6.66634C14.1662 6.20625 13.7935 5.83333 13.3333 5.83333H6.66634C6.20636 5.8335 5.8335 6.20636 5.83333 6.66634V13.3333C5.83333 13.7935 6.20625 14.1662 6.66634 14.1663H13.3333C13.7936 14.1663 14.1663 13.7936 14.1663 13.3333V6.66634ZM15.1663 13.3333C15.1663 14.3459 14.3459 15.1663 13.3333 15.1663H6.66634C5.65396 15.1662 4.83333 14.3457 4.83333 13.3333V6.66634C4.8335 5.65407 5.65407 4.8335 6.66634 4.83333H13.3333C14.3457 4.83333 15.1662 5.65396 15.1663 6.66634V13.3333Z"
      fill="currentColor"
    />
    <path
      d="M10.1663 2.66634C10.1662 2.20929 9.79041 1.83333 9.33333 1.83333H2.66634C2.2094 1.83351 1.83351 2.2094 1.83333 2.66634V9.33333C1.83333 9.79041 2.20929 10.1662 2.66634 10.1663C2.94237 10.1663 3.16616 10.3903 3.16634 10.6663C3.16634 10.9425 2.94248 11.1663 2.66634 11.1663C1.65701 11.1662 0.833328 10.3427 0.833328 9.33333V2.66634C0.833505 1.65712 1.65712 0.833505 2.66634 0.833328H9.33333C10.3427 0.833328 11.1662 1.65701 11.1663 2.66634C11.1663 2.94248 10.9425 3.16634 10.6663 3.16634C10.3903 3.16616 10.1663 2.94237 10.1663 2.66634Z"
      fill="currentColor"
    />
  </svg>
);
